import Vue from "vue";
import Input from "./components/ui/Input";
import Textarea from "./components/ui/Textarea";
import Variant from "./components/ui/Variant";
import Button from "./components/ui/Button";

Vue.component("ui-input", Input);
Vue.component("ui-textarea", Textarea);
Vue.component("ui-variant", Variant);
Vue.component("ui-button", Button);
